import React from 'react';
import Icon from '../atoms/Icon';

function SocialXIcon(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <path d="M5.33333 0C2.40894 0 0 2.40894 0 5.33333V26.6667C0 29.5911 2.40894 32 5.33333 32H26.6667C29.5911 32 32 29.5911 32 26.6667V5.33333C32 2.40894 29.5911 0 26.6667 0H5.33333ZM5.33333 3.55556H26.6667C27.6712 3.55556 28.4444 4.32884 28.4444 5.33333V26.6667C28.4444 27.6712 27.6712 28.4444 26.6667 28.4444H5.33333C4.32884 28.4444 3.55556 27.6712 3.55556 26.6667V5.33333C3.55556 4.32884 4.32884 3.55556 5.33333 3.55556ZM6.57986 7.11111L13.5868 17.125L6.94444 24.8889H9.3125L14.6493 18.6389L19.0174 24.8889H25.8438L18.4028 14.2396L24.4861 7.11111H22.1563L17.3507 12.7292L13.4271 7.11111H6.57986ZM9.89583 8.86806H12.5382L22.5486 23.1319H19.8889L9.89583 8.86806Z" fill="currentColor"/>
    </Icon>
  );
}

export default React.forwardRef(SocialXIcon);